// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2462) return "static/chunks/2462-b584b064183ee860.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5983":"67956f9a737800cc","8122":"2f5c6ca6ffaf2627","8364":"841673c3c7e60bac"}[chunkId] + ".js";
};